import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DashBoardComponent } from './dashboard.component';
import { BarrasAgrupadasComponent } from './barras-agrupadas/barras-agrupadas.component';
import { BarrasHorizontalAgrupadasComponent } from './barras-horizontal-agrupadas/barras-horizontal-agrupadas.component';
import { BarrasHorizontalNormalizadasComponent } from './barras-horizontal-normalizadas/barras-horizontal-normalizadas.component';
import { BarrasHorizontalComponent } from './barras-horizontal/barras-horizontal.component';
import { BarrasNormalizadasComponent } from './barras-normalizadas/barras-normalizadas.component';
import { BarrasComponent } from './barras/barras.component';
import { LineasComponent } from './lineas/lineas.component';
import { PieGridComponent } from './pie-grid/pie-grid.component';
import { PieComponent } from './pie/pie.component';
import { Pie2Component } from './pie2/pie2.component';
import { BubbleComponent } from './bubble/bubble.component';
import { ComboChartComponent } from './combo-charts/combo-chart.component';
import { Bubble2Component } from './bubble2/bubble2.component';

@NgModule({
    declarations: [
        DashBoardComponent,
        LineasComponent,
        PieComponent,
        Pie2Component,
        PieGridComponent,
        BarrasAgrupadasComponent,
        BarrasNormalizadasComponent,
        BarrasHorizontalComponent,
        BarrasHorizontalAgrupadasComponent,
        BarrasHorizontalNormalizadasComponent,
        BubbleComponent,
        Bubble2Component,
        ComboChartComponent,
    ],
    imports: [CommonModule, NgxChartsModule],
    exports: [
        LineasComponent,
        PieComponent,
        Pie2Component,
        PieGridComponent,
        BarrasAgrupadasComponent,
        BarrasNormalizadasComponent,
        BarrasHorizontalComponent,
        BarrasHorizontalAgrupadasComponent,
        BarrasHorizontalNormalizadasComponent,
        BubbleComponent,
        Bubble2Component,
        ComboChartComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardModule {}
